const settings =
  process.env.NODE_ENV !== 'development'
    ? {
        GET_MELDUNGEN_URL: 'https://www.biwapp.de/widget/dataBiwappProxy',
        CREATE_UPDATE_SUBSCRIPTION_URL:
          'https://dienste-biwapp.akamaized.net/appservice_biwapp_v1_4/Service.asmx/CreateOrUpdateSubscription',
        REMOVE_SUBSCRIPTION_URL:
          'https://dienste-biwapp.akamaized.net/appservice_biwapp_v1_4/Service.asmx/Unsubscribe',
        CREATE_UPDATE_USER_URL:
          'https://dienste-biwapp.akamaized.net/appservice_biwapp_v1_4/Service.asmx/CreateOrCheckUser',
        LANDKREISE_URL:
          'https://dienste-biwapp.akamaized.net/biwapptest/Service.asmx/GetLandkreise',
        LAT_LNG_URL: 'https://dienste-biwapp.akamaized.net/biwapptest/Service.asmx/GetLatLngForID',
      }
    : {
        GET_MELDUNGEN_URL: 'https://www.biwapp.de/widget/dataBiwappProxy',
        CREATE_UPDATE_SUBSCRIPTION_URL:
          'https://dienste-biwapp.akamaized.net/appservice_biwapp_v1_4_dev/Service.asmx/CreateOrUpdateSubscription',
        REMOVE_SUBSCRIPTION_URL:
          'https://dienste-biwapp.akamaized.net/appservice_biwapp_v1_4_dev/Service.asmx/Unsubscribe',
        CREATE_UPDATE_USER_URL:
          'https://dienste-biwapp.akamaized.net/appservice_biwapp_v1_4_dev/Service.asmx/CreateOrCheckUser',
        LANDKREISE_URL:
          'https://dienste-biwapp.akamaized.net/biwapptest/Service.asmx/GetLandkreise',
        LAT_LNG_URL: 'https://dienste-biwapp.akamaized.net/biwapptest/Service.asmx/GetLatLngForID',
      };

export default settings;



// WEBPACK FOOTER //
// ./src/js/constants/settings.js